import React from 'react';
import PropTypes from 'prop-types';
import Pagination from '@prism/pagination';

class PrismPaiger extends React.PureComponent {
    static propTypes = {
        currentPage: PropTypes.number.isRequired,
        totalPages: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired
    };

    render() {
        return (
            <div className='prism-sandbox'>
                <Pagination {...this.props} />
            </div>
        );
    }
}

export default PrismPaiger;
